import styled from 'styled-components';

const NextIconCalendar = styled.div`
  display: inline-flex;
  justify-content: center;
  align-items: center;
  background-color: rgba(45, 54, 87, 0.25);
  color: var(--way-palette-black-30);
  font-size: 24px;
  position: absolute;
  margin-top: -2px;
  top: 19px;
  right: 13px;
  width: 26px;
  height: 26px;
  border-radius: 50%;
  padding-left: 2px;
`;

export default NextIconCalendar;
